import { PushRealisationsClients } from '@components/push-realisations-clients/models';
import { Block } from '@shared/models';

export const pushRealisationsClientsMock: Block<PushRealisationsClients> = {
  type: 'push-realisations-clients',
  data: {
    title: {
      text: `Le meilleur de SoCoo'c Troyes, [[désolés si ça vous donne envie d'y déménager]]`,
      as: 'span',
    },
    cta: {
      label: `Voir toutes les cuisines clients`,
      url: `/mock-cuisines/clients`,
    },
  },
};
